<template>
    <div class="back-button">
        <b-button
            v-b-tooltip.hover
            size="sm"
            variant="icon"
            :title="$translate('back')"
            @click="navigateBack"
        >
            <i class="fa fa-chevron-left" />
        </b-button>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'BackButton',
    computed: {
        ...mapState({
            selectedTreatment: state => state.timelapse.selectedTreatment,
            selectedSlide: state => state.timelapse.selectedSlide
        })
    },
    methods: {
        navigateBack() {
            this.$log.navigationEvent('navigate_back')

            this.$store.dispatch('navigation/navigateBack', {
                treatment: this.selectedTreatment,
                slide: this.selectedSlide
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.back-button {
    display: flex;
    background-color: $blue;
    height: var(--sub-header-height);

    .btn {
        margin: 0.25rem 0.5rem 0;

        @media print {
            display: none;
        }
    }
    .fa-chevron-left {
        color: $dark;
        font-size: 13pt;
        // makes icon thinner
        -webkit-text-stroke: 0.1rem $blue;
    }
}
</style>
